// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectGeneralForm_wrapper__LULGP","submitWrapper":"EditProjectGeneralForm_submitWrapper__ggyrl"};